import { Reveal } from "@/components/motion/Reveal";
import { Rich } from "@/components/common/Rich";

// Spec bar: indexed stat cells on a hairline grid.
export const CredibilityStrip = ({ stats = [] }) => (
  <dl className="grid border border-line bg-surface sm:grid-cols-2 lg:grid-cols-4" data-testid="credibility-strip">
    {stats.map((s, i) => (
      <Reveal
        key={s.label}
        delay={i * 0.08}
        className={`group flex flex-col gap-5 border-line p-6 transition-colors duration-300 hover:bg-accent-soft sm:p-8 ${i ? "border-t sm:border-t-0" : ""} ${i % 2 ? "sm:border-l" : ""} ${i > 1 ? "sm:border-t lg:border-t-0" : ""} ${i ? "lg:border-l" : ""}`}
        data-testid={`credibility-stat-${i}`}
      >
        <span className="order-1 font-mono text-[12px] text-muted">{String(i + 1).padStart(2, "0")}</span>
        <dt className="order-3 max-w-[16rem] text-[14px] leading-snug text-muted">{s.label}</dt>
        <dd className="order-2 font-display text-5xl font-semibold leading-none tracking-[-0.04em] text-accent lg:text-6xl [&_.ph]:inline-block [&_.ph]:text-[13px] [&_.ph]:leading-normal">
          <Rich text={s.value} />
        </dd>
      </Reveal>
    ))}
  </dl>
);
